module.exports = __webpack_public_path__ + "img/13.221dd140.jpg";